import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { MyContext } from '../InitialSetup/MyProvider';
import { updateDeviceToken, getLobbyBanner, getLobbyFixtures } from "../WSHelper/WSCallings";
import { NavLink } from "react-router-dom";
import { Utilities, _isEmpty, _filter, _Map, BannerRedirectLink, parseURLDate } from '../Utilities/Utilities';
import { CollectionInfoModal, ContestDetailModal } from "../Modals";
import { NoDataView, LobbyBannerSlider, LobbyShimmer } from '../Component/CustomComponent';
import CustomHeader from '../components/CustomHeader';
import ls from 'local-storage';
import Images from '../components/images';
import WSManager from "../WSHelper/WSManager";
import FixtureContest from "./FixtureContest";
import Filter from "../components/filter";
import * as AppLabels from "../helper/AppLabels";
import * as WSC from "../WSHelper/WSConstants";
import * as Constants from "../helper/Constants";
var bannerData = {}

export class Lobby extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            OriginalContestList: [],
            ContestList: [],
            BannerList: [],
            ShimmerList: [1, 2, 3, 4, 5],
            showContestDetail: false,
            FixtureData: '',
            isLoaderShow: false,
            isListLoading: false,
            offset: 0,
            showLobbyFitlers: false,
            league_id: "",
            filterArray: [],
            sports_id: Constants.AppSelectedSport,
            showCollectionInfo: false,
            canRedirect: true,
            filterLeagueList:[]
        }
    }

    ContestDetailShow = (data) => {
        this.setState({
            showContestDetail: true,
            FixtureData: data
        });
    }
    /**
    * @description this method to hide contest detail model,
    */
    ContestDetailHide = () => {
        this.setState({
            showContestDetail: false,
        });
    }
    /**
     * 
     * @description method to display collection info model.
     */
    CollectionInfoShow = (event) => {
        // event.preventDefault();
        event.stopPropagation();
        this.setState({
            showCollectionInfo: true
        }, () => {
        });
    }
    /**
     * 
     * @description method to hide collection info model.
     */
    CollectionInfoHide = () => {
        this.setState({
            showCollectionInfo: false,
        });
    }
    /**
     * @description this method to to open create contest screen
     */
    createContest = () => {
        this.props.history.push('/create-contest')
    }

    /**
     * @description this method to to open Have a league code screen
     */
    joinContest = () => {
        if (WSManager.loggedIn()) {
            this.props.history.push({ pathname: '/private-contest' })
        }
        else {
            this.props.history.push({ pathname: '/signup' })
        }
    }
    /**
     * @description this method will be call when user click join buttonn from contestt detail model screen,
     * in case user in not logged in then signup/login screen will display
     * @param data - contest model 
     */
    onSubmitBtnClick = (data) => {
        if (!WSManager.loggedIn()) {
            setTimeout(() => {
                this.props.history.push({ pathname: '/signup' })
                Utilities.showToast(AppLabels.Please_Login_Signup_First, 3000);
            }, 10);
        } else {
            let dateformaturl = parseURLDate(data.season_scheduled_date);
            WSManager.clearLineup();
            let lineupPath = '/lineup/' + data.home + "-vs-" + data.away + "-" + dateformaturl
            this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { FixturedContest: this.state.FixtureData, LobyyData: data } })
        }
    }

    /**
     * @description - this method is to display contest of a fixture on click event
     * @param data - fixture model
     */
    gotoDetails = (data, event) => {
        event.preventDefault();

        if (Constants.SELECTED_GAMET == Constants.GameType.MultiGame ) {
            if (data.match_list.length == 1) {
                data.home = data.match_list[0].home;
                data.home_flag = data.match_list[0].home_flag;
                data.away = data.match_list[0].away;
                data.away_flag = data.match_list[0].away_flag;
            }
        }

        let dateformaturl = parseURLDate(data.season_scheduled_date);
        this.setState({ LobyyData: data })

        let contestListingPath = Utilities.getSelectedSportsForUrl().toLowerCase() + '/contest-listing/' + data.collection_master_id + '/' + data.home + "-vs-" + data.away + "-" + dateformaturl + "?sgmty=" +  btoa(Constants.SELECTED_GAMET);
        this.props.history.push({ pathname: contestListingPath.toLowerCase(), state: { FixturedContest: this.state.FixtureData, LobyyData: data, lineupPath: contestListingPath } })

    }

    /**
     * @description - this is life cycle method of react
     */
    componentDidMount() {
        if (window.ReactNativeWebView) {
            let data = {
                action: 'SessionKey',
                targetFunc: 'SessionKey',
                page:'lobby',
                SessionKey: WSManager.getToken() ?  WSManager.getToken() : WSManager.getTempToken() ? WSManager.getTempToken():'',
            }
            window.ReactNativeWebView.postMessage(JSON.stringify(data));
        }
        if (this.props.location.pathname == '/lobby') {
            let { sports_id } = this.state;
            WSManager.setFromConfirmPopupAddFunds(false);
            let league_id = this.getSportsLeagueId(sports_id, Constants.LOBBY_FILTER_ARRAY);
            this.setState({ isLoaderShow: true, sports_id, league_id, filterArray: Constants.LOBBY_FILTER_ARRAY }, () => {
                this.lobbyContestList(0);
                this.getBannerList();
            })

            //Analytics Calling 
            WSManager.googleTrack(WSC.GA_PROFILE_ID, 'fixture');
            if (WSManager.loggedIn()) {
                WSManager.googleTrackDaily(WSC.GA_PROFILE_ID, 'loggedInusers');
            }
            this.checkOldUrl();
        }
        this.handelNativeGoogleLogin()
        if (!ls.get('isDeviceTokenUpdated')) {

            let token_data = {
                action: 'push',
                targetFunc: 'push',
                type: 'deviceid',
            }
            this.sendMessageToApp(token_data)
        }
        setTimeout(() => {
            let push_data = {
                action: 'push',
                targetFunc: 'push',
                type: 'receive',
            }
            this.sendMessageToApp(push_data)
        }, 300);
    }

    UNSAFE_componentWillMount = () => {
        this.enableDisableBack(false)
    }

    enableDisableBack(flag){
        if (window.ReactNativeWebView) {
            let data = {
                action: 'back',
                type: flag,
                targetFunc:'handleLoginReceived'
            }
            this.sendMessageToApp(data);
        }
    }


    componentWillUnmount() {
        let data = {
            action: 'back',
            targetFunc: 'back',
            type: false,
        }
        this.sendMessageToApp(data);
    }

    /**
     * @description method will be called when changing sports
     */
    reload = (nextProps) => {
        if (window.location.pathname.startsWith("/lobby")) {
            let league_id = this.getSportsLeagueId(nextProps.selectedSport, this.state.filterArray);
            this.setState({
                ContestList: [],
                league_id: league_id,
                offset: 0,
                sports_id: nextProps.selectedSport,
            }, () => {
                WSManager.setFromConfirmPopupAddFunds(false);
                this.lobbyContestList(0);
                this.getBannerList();
                Filter.reloadLobbyFilter();
            })
        }
    }

    sendMessageToApp(action) {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify(action));
        }
    }

    handelNativeGoogleLogin() {
        window.addEventListener('message', (e) => {


            if(e.data.locale != undefined){
                WSManager.setAppLang(e.data.locale);

            }
            if (e.data.UserProfile != undefined) {
                WSManager.setProfile(e.data.UserProfile);
            } 
            if (e.data.LoginSessionKey != '' && e.data.LoginSessionKey != undefined) {
                WSManager.setToken(e.data.LoginSessionKey);
            }   
            if (e.data.isMobileApp != '' && e.data.isMobileApp != undefined) {
                WSManager.setIsMobileApp(e.data.isMobileApp);
            }  



            if (e.data.action == 'push' && e.data.type == 'deviceid') {
                if(e.data.token && e.data.token != WSC.DeviceToken.getDeviceId()){
                    WSC.DeviceToken.setDeviceId(e.data.token);
                    this.updateDeviceToken();
                }
            }
            else if (e.data.action == 'push' && e.data.type == 'receive') {
                let pathName = '';
                if (e.data.notif.notification_type == '120') {//deposit promotion
                    pathName = 'add-funds';
                }
                else if (e.data.notif.notification_type == '121') {// promotion for contes
                    pathName = Utilities.getSelectedSportsForUrl().toLowerCase() + '/contest/' + e.data.notif.contest_unique_id
                }
                else if (e.data.notif.notification_type == '123') {// admin refer a friend
                    pathName = 'refer-friend';
                }
                else if (e.data.notif.notification_type == '124' ||
                    e.data.notif.notification_type == '131' ||
                    e.data.notif.notification_type == '132' ||
                    e.data.notif.notification_type == '300' ||
                    e.data.notif.notification_type == '440' ) {//124-promotion for fixture 131-match delay  132-lineup announced
                    ls.set('selectedSports', e.data.notif.sports_id);
                    Constants.setValue.setAppSelectedSport(e.data.notif.sports_id);
                    let dateformaturl = parseURLDate(e.data.notif.season_scheduled_date);
                   // pathName = Utilities.getSelectedSportsForUrl().toLowerCase() + '/contest-listing/' + e.data.notif.collection_master_id + '/' + e.data.notif.home + "-vs-" + e.data.notif.away + "-" + dateformaturl + "?sgmty=" +  btoa(Constants.SELECTED_GAMET);
                    let data = e.data.notif;
                    let contestListingPath = '/' + Utilities.getSelectedSportsForUrl().toLowerCase() + '/contest-listing/' + data.collection_master_id + '/' + data.home + "-vs-" + data.away + "-" + dateformaturl + "?sgmty=" +  btoa(Constants.SELECTED_GAMET);
                    //alert(contestListingPath.toLowerCase())
                    this.props.history.push({ pathname: contestListingPath.toLowerCase()})
                    contestListingPath = '';
                    return;
            
                }
                else if (e.data.notif.notification_type == '135') {// custom notification
                    if (e.data.notif.custom_notification_type == 1) {
                        pathName = 'lobby';
                    }
                    else if (e.data.notif.custom_notification_type == 2) {
                        pathName = 'my-wallet';
                    }
                    else if (e.data.notif.custom_notification_type == 3) {
                        pathName = 'my-profile';
                    }
                    else if (e.data.notif.custom_notification_type == 4) {
                        pathName = 'my-contests?contest=upcoming';
                    }
                    else if (e.data.notif.custom_notification_type == 5) {
                        pathName = 'refer-friend';
                    }
                    else if (e.data.notif.custom_notification_type ==7) {
                        pathName = 'add-funds';
                    }
                    else {
                        pathName = 'lobby';
                    }
                }
                if (pathName != '') {
                    this.props.history.push({ pathname: pathName });
                }
            }
            else if (e.data.action == 'app_dep_linking' && e.data.type == 'android') {
                let can = ls.get('canRedirect');
                if (can == null || can) {
                    this.blockMultiRedirection()
                    let pathName = e.data.pathName;
                    if (pathName) {
                        this.props.history.push(pathName);
                    }
                }
            }
            else if (e.data.action == 'app_dep_linking' && e.data.type == 'reset') {
                ls.set('canRedirect', true)
            }
        });
    }

    blockMultiRedirection() {
        ls.set('canRedirect', false)
        setTimeout(() => {

            ls.set('canRedirect', true)
        }, 1000 * 5);
    }

    updateDeviceToken = () => {
        let param = {
            "device_type": WSC.deviceTypeAndroid,
            "device_id": WSC.DeviceToken.getDeviceId(),
        }
        if(WSManager.loggedIn() && !Constants.IS_SPORTS_HUB){
            updateDeviceToken(param).then((responseJson) => {
            })
        }
    }

    checkOldUrl() {
        let url = window.location.href;
        if (!url.includes('#') && window.location.pathname === "/lobby") {
            if (Utilities.getSelectedSportsForUrl())
                window.history.replaceState("", "", window.location.pathname + "#" + Utilities.getSelectedSportsForUrl());
        }
    }

    /**
     * @description - method to get fixtures listing from server/s3 bucket
     */
    lobbyContestList = async (offset) => {
        if (Constants.AppSelectedSport == null)
            return;

        let param = {
            "sports_id": Constants.AppSelectedSport
        }

        this.setState({ isLoaderShow: true, isListLoading: true })
        delete param.limit;
        var api_response_data = await getLobbyFixtures(param);
        if (api_response_data) {
            this.setState({ isLoaderShow: false })
            if (offset == 0) {
                let tmpArray = [];
                let tmpLeagues = []; 
                _Map(api_response_data,(obj)=>{
                    if (Utilities.minuteDiffValue({ date: obj.game_starts_in }) < 0) {
                        tmpArray.push(obj);
                        let objLeague = { league_id: obj.league_id, league_name: obj.league_name }
                        if (tmpLeagues.filter(e => e.league_id === objLeague.league_id).length === 0) {
                            tmpLeagues.push(objLeague)
                        }
                    }
                })
                let sortList = tmpArray.sort((a, b) => new Date(a.season_scheduled_date) - new Date(b.season_scheduled_date)); 
                let pinFixtures = []
                let normalFixture = []
                _Map(sortList, (obj) => {
                    if (obj.is_pin_fixture == 1) {
                        pinFixtures.push(obj)
                    } else {
                        normalFixture.push(obj)
                    }
                })
                this.setState({ 
                    ContestList: [...pinFixtures, ...normalFixture], //sortList, 
                    OriginalContestList: [...pinFixtures, ...normalFixture] , //sortList, 
                    filterLeagueList: tmpLeagues 
                }, () => {
                    if (Constants.LOBBY_FILTER_ARRAY.length > 0) {
                        this.filterLobbyResults({ league_id: Constants.LOBBY_FILTER_ARRAY[0].league_id })
                    }
                })
            } else {
                let tmpArray = [] 
                _Map(api_response_data,(obj)=>{
                    if (Utilities.minuteDiffValue({ date: obj.game_starts_in }) < 0) {
                        tmpArray.push(obj);
                    }
                })
                this.setState({ ContestList: [...this.state.ContestList, ...tmpArray], OriginalContestList: [...this.state.ContestList, ...tmpArray] });
            }
            this.setState({ offset: api_response_data.offset })
        }
        this.setState({ isListLoading: false })
    }

    getSportsLeagueId(sports_id, filterArray) {

        let league_id = '';
        for (let i = 0; i < filterArray.length; i++) {
            if (filterArray[i].sports_id == sports_id) {
                league_id = filterArray[i].league_id;
            }
        }
        return league_id;
    }

    /** 
    @description hide lobby filters 
    */
    hideFilter = () => {
        this.setState({ showLobbyFitlers: false })
        this.props.hideFilterData()
    }

    /** 
    @description show lobby filters 
    */
    showFilter = () => {
        this.setState({ showLobbyFitlers: true })
    }

    /** 
    @description Apply filters and load data accordingly
    */
    filterLobbyResults = (filterObj) => {
        let league_id = filterObj.league_id ? filterObj.league_id : "";
        this.setState({ league_id: league_id }, function () {
            this.filterFixturesLocally(league_id)
        })

        let filterArray = this.setFilterArray(league_id);
        Constants.setValue.setFilter(filterArray);
        this.setState({ league_id: league_id, showLobbyFitlers: false, offset: 0, filterArray: filterArray })
        this.props.hideFilterData()
    }

    filterFixturesLocally(leagueIds) {
        let allFixtures = this.state.OriginalContestList;
        if (leagueIds == '') {
            this.setState({ ContestList: allFixtures })
        }
        else {
            let filteredList = [];
            for (var i = 0; i < allFixtures.length; i++) {
                if (leagueIds.includes(allFixtures[i].league_id)) {
                    filteredList.push(allFixtures[i])
                }

            }

            this.setState({ ContestList: filteredList })
        }
    }

    setFilterArray(league_id) {
        let { filterArray } = this.state;

        let hasFilter = false;
        if (filterArray.length > 0) {
            for (let i = 0; i < filterArray.length; i++) {
                if (filterArray[i].sports_id == this.state.sports_id) {
                    hasFilter = true;
                    filterArray[i].league_id = league_id;
                }
            }
        }

        if (!hasFilter && league_id != "") {
            let filterObj = {
                'sports_id': this.state.sports_id,
                'league_id': league_id,
            }
            filterArray.push(filterObj);
        }

        return filterArray;
    }

    /** 
     * @description api call to get baner listing from server
    */
    getBannerList = () => {
        let sports_id = Constants.AppSelectedSport;
        
        if (sports_id == null)
            return;
        if (bannerData[sports_id]) {
            this.parseBannerData(bannerData[sports_id])
        } else {
            setTimeout(async () => {
                this.setState({ isLoaderShow: true })
                let param = {
                    "sports_id": sports_id
                }
                var api_response_data = await getLobbyBanner(param);
                if (api_response_data) {
                    bannerData[sports_id] = api_response_data;
                    this.parseBannerData(api_response_data)
                }
                this.setState({ isLoaderShow: false })
            }, 1500);
        }
    }

    /** 
     * @description call to parse banner data
    */
    parseBannerData = (bdata) => {
        let refData = '';
        let temp = [];
        _Map(this.getSelectedbanners(bdata), (item, idx) => {
            if (item.banner_type_id == 2) {
                refData = item;
            }
            if (item.banner_type_id == 1) {
                let dateObj = Utilities.getUtcToLocal(item.schedule_date)
                if (Utilities.minuteDiffValue({ date: dateObj }) < 0) {
                    temp.push(item);
                }
            }
            else {
                temp.push(item);
            }
        })
        if(refData){
            setTimeout(() => {
                CustomHeader.showRCM(refData);
            }, 200);
        }
        this.setState({ BannerList: temp })
    }

    /** 
     * @description call to get selected banner data
    */
    getSelectedbanners(api_response_data) {
        let tempBannerList = [];
        for (let i = 0; i < api_response_data.length; i++) {
            let banner = api_response_data[i];
            if (WSManager.getToken() && WSManager.getToken() != '') {
                if (banner.banner_type_id == Constants.BANNER_TYPE_REFER_FRIEND
                    || banner.banner_type_id == Constants.BANNER_TYPE_DEPOSITE) {
                    if (banner.amount > 0)
                        tempBannerList.push(api_response_data[i]);
                }
                else if (banner.banner_type_id == '6') {
                    //TODO for banner type-6 add data
                }
                else {
                    tempBannerList.push(api_response_data[i]);
                }
            }
            else {
                if (banner.banner_type_id == '6') {
                    tempBannerList.push(api_response_data[i]);
                }
            }
        }

        return tempBannerList;
    }

    /**
     * @description method to redirect user on appopriate screen when user click on banner
     * @param {*} banner_type_id - id of banner on which clicked
     */
    redirectLink = (result, isRFBanner) => {
        BannerRedirectLink(result, this.props)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.sports_id != nextProps.selectedSport) {
            this.reload(nextProps);
        }
        if (this.state.showLobbyFitlers != nextProps.showLobbyFitlers) {
            this.setState({ showLobbyFitlers: nextProps.showLobbyFitlers })
        }
    }

    timerCompletionCall = (item) => {
        let fArray = _filter(this.state.ContestList, (obj) => {
            return item.collection_master_id != obj.collection_master_id
        })
        this.setState({
            ContestList: fArray
        })
    }

    goToPREDICTION = () => {
        WSManager.setPickedGameType(Constants.GameType.Pred);
        // window.location.replace("/lobby#" + Utilities.getSelectedSportsForUrl() + "#prediction");

        let gameType = Utilities.getMasterData().sports_hub;
        let HGLIST = _filter(gameType, (obj) => {
            return obj.game_key == Constants.GameType.Pred;
        })
        let lsSport = ls.get('selectedSports');
        if(HGLIST[0].allowed_sports.includes(lsSport)){
            window.location.replace("/lobby#" + Utilities.getSelectedSportsForUrl() + "#prediction");
        }
        else{
            let sport = HGLIST[0].allowed_sports[0];
            ls.set('selectedSports', sport);
            Constants.setValue.setAppSelectedSport(sport);
            window.location.replace("/lobby#" + Utilities.getSelectedSportsForUrl() + "#prediction");
        }
    }

    renderPREDCard = () => {
        if(Utilities.getMasterData().a_sports_prediction_bnr != 1){
            return ''
        }
        let bannerImg = Utilities.getMasterData().sports_prediction_bnr;
        if (Constants.IS_PREDICTION) {
            return ( bannerImg ?
                <li onClick={this.goToPREDICTION} className="prd-card-img-only" >
                    <img className="img-shape" src={Utilities.getSettingURL(bannerImg)} alt='' />
                </li>
                :
                <li onClick={this.goToPREDICTION} className="dfs-card prd-card" >
                    <img className="img-dfs-shape" src={Images.PRD_SHAPE_IMG} alt='' />
                    <div className="dfs-c">
                        <img className="img-dfs" src={Images.PRD_IMG} alt='' />
                        <p>Play Prediction<br />& Win Coins to Redeem for Exciting Offers & Prizes</p>
                    </div>
                </li>
                )
        }
        return ''
    }

    render() {

        const {
            showContestDetail,
            FixtureData,
            isLoaderShow,
            showCollectionInfo,
            BannerList,
            league_id,
            showLobbyFitlers,
            ShimmerList,
            ContestList,
            isListLoading,
        } = this.state

        let FitlerOptions = {
            showLobbyFitler: showLobbyFitlers,
            filtered_league_id: league_id
        }

        let bannerLength = BannerList.length;

        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className="transparent-header web-container tab-two-height pb0">
                        <Filter customLeagues={this.state.filterLeagueList} leagueList={league_id} {...this.props} FitlerOptions={FitlerOptions} hideFilter={this.hideFilter} filterLobbyResults={this.filterLobbyResults}></Filter>
                        <div>
                            <div className={bannerLength > 0 ? 'banner-v animation' : 'banner-v'}>
                                {
                                    bannerLength > 0 && <LobbyBannerSlider BannerList={BannerList} redirectLink={this.redirectLink.bind(this)} />
                                }
                            </div>
                            {
                                WSManager.loggedIn() && ContestList.length > 0 &&
                                <div className={"contest-action" + (bannerLength == 0 ? ' mt15' : '')}>
                                    {
                                        Utilities.getMasterData().private_contest == '1' &&
                                        <NavLink exact to={"/create-contest"} className="top-buttons btn btnStyle btn-rounded small">
                                            <span className="text-uppercase">{AppLabels.Create_a_Contest}</span>
                                        </NavLink>
                                    }
                                    <NavLink exact to="/private-contest" className="top-buttons btn btnStyle btn-rounded small">
                                        <span className="league-code-btn text-uppercase">
                                            {AppLabels.JOIN_CONTEST}
                                        </span>
                                    </NavLink>
                                </div>
                            }
                            <div className="upcoming-lobby-contest">
                                {
                                    ContestList.length > 0 &&
                                    <div className="top-section-heading">{AppLabels.UPCOMING} {AppLabels.MATCHES}</div>
                                }
                                <Row className='mt15'>
                                    <Col sm={12}>
                                        <Row>
                                            <Col sm={12}>
                                                    <ul className="collection-list-wrapper lobby-anim">
                                                        {
                                                            (ContestList.length == 0 && isListLoading) &&
                                                            ShimmerList.map((item, index) => {
                                                                return (
                                                                    <LobbyShimmer key={index} />
                                                                )
                                                            })
                                                        }

                                                        {
                                                            ContestList.length > 0 &&
                                                            ContestList.map((item, index) => {
                                                                return (
                                                                    <React.Fragment key={item.collection_master_id} >
                                                                        <FixtureContest
                                                                            {...this.props}

                                                                            indexKey={item.collection_master_id}
                                                                            ContestListItem={item}
                                                                            gotoDetails={this.gotoDetails}
                                                                            CollectionInfoShow={this.CollectionInfoShow}
                                                                            IsCollectionInfoHide={this.CollectionInfoHide}
                                                                            timerCallback={() => this.timerCompletionCall(item)}
                                                                        />
                                                                        {
                                                                            index === 1 && this.renderPREDCard()
                                                                        }
                                                                    </React.Fragment>
                                                                );
                                                            })
                                                        }
                                                        {
                                                            (ContestList.length < 2 && !isListLoading) && this.renderPREDCard()
                                                        }

                                                        {
                                                            (ContestList.length == 0 && !isListLoading) &&
                                                            <NoDataView
                                                                BG_IMAGE={Images.no_data_bg_image}
                                                                CENTER_IMAGE={Images.BRAND_LOGO_FULL}
                                                                MESSAGE_1={AppLabels.NO_FIXTURES_MSG1}
                                                                MESSAGE_2={AppLabels.NO_FIXTURES_MSG2}
                                                                onClick_2={this.joinContest}
                                                            />
                                                        }
                                                    </ul>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>

                        </div>
                        {showContestDetail &&
                            <ContestDetailModal IsContestDetailShow={showContestDetail} onJoinBtnClick={this.onSubmitBtnClick} IsContestDetailHide={this.ContestDetailHide} OpenContestDetailFor={FixtureData} />
                        }
                        {showCollectionInfo &&
                            <CollectionInfoModal IsCollectionInfoShow={showCollectionInfo} IsCollectionInfoHide={this.CollectionInfoHide} />
                        }
                    </div>
                )}
            </MyContext.Consumer>

        )
    }
}

export default Lobby
